import React, {useState} from "react";
import {Modal, Select, Tooltip} from "antd";
import styles from "./scss/CallDialpadScreenright.module.scss";
import Quickstyles from "./scss/QuickCall.module.scss";
import callred from "../../../../styles/images/closecall.svg";
import Draggable from "react-draggable";
import {useHistory} from "react-router-dom";
import store from "../../../../context/store/store";
import {Types} from "../../../../context/action/action";
import styles2 from "../../callsDialPad/scss/dialpadmainicon.module.scss";

import {
  acceptCall,
  callEndWithGiud,
  callnow,
  currentCallEnd,
  holdCall,
  holdCallWithGuid,
  initiateCall,
  rejectCall,
  removeAllnMuteAll
} from "../../../../base/callService/callService";
import DialConnecting from "../numberconnecting";
import {calldetail, initialCallStateModel, updatedCallStore} from "../../../../models/callModel";
import {useSelector} from "react-redux";
//import ConferenceCalls from "../conferencecall";
//import TransferCalls from "../transfercalls";
import CallDialTimer from "../timer";
import DialPadContactLists from "../contactlists";
import DialInputs from "../numbertyping";
import DialPadNumber from "../dialpadnumber";
import {incomingCallDetail} from "../../../../base/callService/callsApiService";
import { SocketChatService } from "../../../../base/socketChatService";
import {
  filterSingleStatusInGroup,
  filterUserStatus,
  findCallHost,
  frameCallProfile,
  frameMultiGroupCall,
  getCurrentCallDetail,
  groupCurrentUserMute,
  toastInformation
} from "../../../../base/callService/common";
import {config} from "../../../../base/constant";
import {callPlusIconAction, storeActiveLogs} from "../../../../base/callService/store_mining";
import {altRecTimer} from "../../../../base/callService/common";
import minikeys from "../../../../styles/images/minikeys.svg";
import {LoginState, UserDetails, contacts} from "../../../../models/model";
import gHold from "../../../../styles/images/onhold.svg";
import gtransfer from "../../../../styles/images/transfer.svg";
import callgreen from "../../../../styles/images/callgreen.svg";
import groupCallEndatyn from "../../../../styles/images/groupcall1.svg";
import groupCallhldAtyn from "../../../../styles/images/groupcall2.svg";
//import audioWave from "../../../../styles/images/Audio-wave.svg";
//import { CallUnHold } from "unifiedring-sdk/dist/components/call/Call";
import { URButton } from "../../../../shared/widgets/button";
import CallMainWindowTeam from "../callMainWindowTeam";
import DialKeypad from "../kayboard";
import SpecificMemberLists from "../../callsWidgets/memberList/specificMemberList";
import _ from "lodash";
import { v4 as uuidv4 } from 'uuid';
import { setInitial } from "../../../../base/socketChatService/newChat";

// type incomingDetailProps = { incomingDetail: any;};

type CallDialPadMainState = {
  contactListUI: boolean;
  isActive: boolean;
  contactListshow: boolean;
  callInputBox: string;
  contactName: string;
  isActiveWindow: boolean;
  isEndModal:boolean;
  endId:string;
};
type CallMainWindowProps = {
  dialpadUI?: any
};
type CallWindowState = {
  isAddCall: boolean,
  isKeyPad: boolean,
  ifFlipKey: string,
  mic_Search: string,
  spec_Search: string,
  transferType: string,
  open_ASR_mic: boolean,
  isModalVisible: boolean,
  isFlippedDevice: string,
  isTransferPopup: boolean,
  open_ASR_speaker: boolean,
  tempAllContacts: Array<any>,
  allContacts: Array<any>,
  searchText: string,
  chooseParticipants: Array<any>
  isEndModal:boolean,
  isAssignModal:boolean
};
const CallMiniWindowScreen = () => {
  const {updatedCallList}: updatedCallStore = useSelector((state: updatedCallStore) => state);
  //let callerInfo: calldetail[] = updatedCallList.callDetails || [];
  let { activeLogs} = store.getState().callReducer||{};
  let updatedCallRedux: calldetail[] = updatedCallList.callDetails || [];
  const callState: initialCallStateModel = useSelector((state: initialCallStateModel) => state);
  const {incomingCallWindow} = callState;
  const incomingInfo: any = incomingCallWindow.incomingCallDetail;

  const [getData, setData] = useState<CallDialPadMainState>({
    isActiveWindow: updatedCallList.callPlusIcon ? true : false,
    isActive: false,
    contactListshow: false,
    callInputBox: "",
    contactName: "",
    contactListUI: false,
    isEndModal:false,
    endId:''
  });
  let history = useHistory();
  const [getCallWindow, setCallWindow] = useState<CallWindowState>
    ({
      isAddCall: false, isKeyPad: false, isModalVisible: false,
      isFlippedDevice: '', ifFlipKey: '', mic_Search: '', spec_Search: '',
      transferType: '', open_ASR_mic: false, open_ASR_speaker: false, isTransferPopup: false,isEndModal:false,
      tempAllContacts: [], allContacts: [], searchText: '', chooseParticipants: [],isAssignModal:false
    });

  let activeCallDetail: any = getCurrentCallDetail();

  let callReducer = store.getState().updatedCallList || [];
  let is_No_Mapping:boolean=false;
  let anotherCall:any = callReducer.callDetails || {};
  let { allContacts, tempAllContacts, chooseParticipants, searchText } = getCallWindow;
  if(callReducer.callDetails.length === 2 && callReducer.centerWindow === "callWindow" ) {
    anotherCall = anotherCall.find((e: calldetail) => (e.holdState === true));
     is_No_Mapping = true; 
  }

  const maxCallWindow = () => {
    if (updatedCallList.callDetails.length === 2) {
      if(is_No_Mapping) { holdCallWithGuid(anotherCall?.guid); }
      store.dispatch({
        type: Types.CALL_POPOUT,
        payloads: {
          isWindowSlide: false,
          minimizedWindow: true,
          centerWindow:"callWindow",
          rightSideWindow: "participantList",
          isTranscriptionOnOff: true
        }
      });
    } else {
      store.dispatch({
        type: Types.CALL_POPOUT,
        payloads: {
          isWindowSlide: false,
          minimizedWindow: false,
          centerWindow: "callWindow",
          rightSideWindow: "participantList",
          isTranscriptionOnOff: true
        }
      });
    }
  };

  /* ------------------------------------------------------------------- */ /* INCOMMING STATUS */

  const calldenied = () => {
    rejectCall(incomingInfo.useragent);
  };
  const CallAcceptBtn = () => {
    let acceptButton: any = document.getElementById('callAccept');
    if(acceptButton){
    acceptButton.style.pointerEvents = 'none';
    acceptButton.style.opacity = '0.5';
    }
    if (history.location.pathname !== "calls") {
      history.push("/calls");
      setTimeout(function () {
        acceptCall(incomingInfo);
      }, 100);
    } else {
      acceptCall(incomingInfo);
    }
  };

  const endAndAccept = () => {
    if(activeCallDetail.isGroupCall){
      if(activeCallDetail.isGroupHost){

        removeAllnMuteAll('RemoveAll',activeCallDetail.guid);
      }else{
        activeLogs.map((e: any) => {
          if (e.guid === activeCallDetail.guid) { e.callStatus = 'Rejoin' }
        });
        storeActiveLogs(activeLogs);
      }
    }
    currentCallEnd();
    CallAcceptBtn();
  };

  const holdAndAccept = () => {
    holdCall();
    CallAcceptBtn();
  };

  /* ------------------------------------------------------------------- */
  const showCallMaxWindow = (userData: any) => {
    if (history.location.pathname !== "calls") {
      history.push("/calls");
      setTimeout(function () {
        maxCallWindow();
      }, 10);
    } else {
      maxCallWindow();
    }
  };
  const toastShow = (message: string, timer?: number) => {
    if (history.location.pathname === '/calls' && !updatedCallList.minimizedWindow) { toastMessageCallWindow(message, timer); }
    else { toastInformation(message, "success"); }
  };
  const quickCallMaxWindow = (userData: any) => {
    if (history.location.pathname !== "/calls") {
      history.push("/calls");
    } else {
      store.dispatch({
        type: Types.UPDATDE_WINDOW_SLIDE,
        payloads: {
          isWindowSlide: true,
          isCallFullScreen: false,
          rightSideWindow: "dialpad",
          isTranscriptionOnOff: true
        }
      });
    }
    callPlusIconAction(false, "");
  };

  const addCallContactNodata = () => {
    setData({...getData, contactListUI: !getData.contactListUI});
  };

  const openContact = () => {
    setData({...getData, isActive: !getData.isActive, contactListshow: true});
  };

  const openKeyboard = () => {
    setData({...getData, isActive: !getData.isActive, contactListshow: false});
  };

  const contactListHide = () => {
    setData({...getData, contactListshow: false});
  };

  const selectedContactList = (ext: string, selectedContactName: string) => {
    setData({
      ...getData,
      contactListshow: false,
      callInputBox: ext.toString(),
      contactName: selectedContactName
    });
  };

  const dialPadKeyBoardevent = (keyValue: string) => {
    let currentUserData: any = incomingCallDetail(keyValue);
    setData({...getData, callInputBox: keyValue, contactName: currentUserData["caller_id"]});
  };

  const dialPadBackSpace = () => {
    let textBoxValue: string = getData.callInputBox.toString();
    if (textBoxValue.length !== 0) {
      textBoxValue = textBoxValue.substring(0, textBoxValue.length - 1);
      let currentUserData: any = incomingCallDetail(textBoxValue);
      setData({...getData, callInputBox: textBoxValue, contactName: currentUserData["caller_id"]});
    }
  };

  const dialPadKeyevent = (key: string) => {
    let inputs: string = getData.callInputBox + key;
    let currentUserData: any = incomingCallDetail(inputs);
    setData({...getData, callInputBox: inputs, contactName: currentUserData["caller_id"]});
  };

  const contactListShow = () => {
    setData({...getData, contactListshow: true});
  };

  const mainCallWindow = () => {
    if (getData.callInputBox !== "") {
      let callCheck: any = callnow(getData.callInputBox, "audio");
      if (callCheck.isCheck) {
        toastInformation(callCheck.error, "failure");
        return true;
      } else {
        initiateCall(getData.callInputBox.toString(), "audio", "", true);
        setData({
          ...getData,
          callInputBox: "",
          contactName: ""
        });
      }
    } else {
      toastInformation(config().CALL_INVALID_NUMBER, "failure");
    }
  };



    const callEndFunction = () => {
      if (updatedCallRedux.length === 1) {
        toastShow('Call Ended', 1000);
        currentCallEnd();
      }
    
    };
  const handleQuickMenuToggle = () => {
    if (updatedCallList.callIconStatus === "quickCall") {
      callPlusIconAction(false, "");
    } else {
      setData({...getData, isActive: !getData.isActive});
    }
  };

  const handleToggle = () => {
    setData({...getData, isActiveWindow: !getData.isActiveWindow});
  };
 
  const holdCallbtn = (userInfo: any) => {
    holdCallWithGuid(userInfo?.guid);
  };
  const cancelEndModal=()=>{
    setData({ ...getData,  isEndModal: false });
  }
  
  const onLeave=()=>{
      activeLogs.map((e: any) => {
        if (e.guid === activeCallDetail.guid) {
           e.callStatus = 'Rejoin'
          }
      });
    storeActiveLogs(activeLogs);
    callEndFunction();
  }
  
  const beforeLeave=()=>{
    if (activeCallDetail.isGroupCall) {
      if (activeCallDetail.isGroupHost) {
        let connectedUsers: Array<any> = filterUserStatus(activeCallDetail.groupCallInfo, 'Connected');
        if (connectedUsers.length >= 1) {
          let connectedUsers: Array<any> = filterUserStatus(activeCallDetail.groupCallInfo, 'Connected');
          setCallWindow({ ...getCallWindow, allContacts: connectedUsers, tempAllContacts: connectedUsers, isAssignModal: true });
        }
        else {
          removeAllnMuteAll('RemoveAll', getData.endId);
          callEndWithGiud(getData.endId);
        }
      }
      else {
        onLeave();
      }
    }
    else {
      callEndFunction();
    }
  };
  

  let userData: any = (is_No_Mapping) ?frameCallProfile(anotherCall) : frameCallProfile(getCurrentCallDetail()||{});
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  let { teamContacsnew }: contacts = store.getState().contactReducer || [];
  let result:boolean = false;
  Object.keys(teamContacsnew).forEach((gKey: any) => {
  let newKey: any = teamContacsnew[gKey];
  Object.keys(newKey).forEach((member: any) => {
    if (((newKey['team_name']) === userData?.combinedNames[0]))
    {
    result =true;
    } 
  });
  });


  const callEndForGroup = () => {
    removeAllnMuteAll('RemoveAll', getData.endId);
    callEndWithGiud(getData.endId);

    // currentCallEnd();

    setData({ ...getData, isEndModal: false });
  }



  const leaveCall=(callId:any)=>{
    activeLogs.map((e: any) => {
      if (e.guid === callId) { e.callStatus = 'Rejoin' }
    });
    storeActiveLogs(activeLogs);
    callEndWithGiud(callId);
    closeEndModal();
    setInitial(false);

  }

  const openEndModel = (callId: any) => {
    let connectedUsers: Array<any> = filterSingleStatusInGroup(activeCallDetail.groupCallInfo, 'Connected',activeCallDetail.isHostId);
    if (connectedUsers.length >= 1) {
      setData({ ...getData, isEndModal: true, endId: callId });
    }
    else {
      removeAllnMuteAll('RemoveAll', callId);
      callEndWithGiud(callId);
    }
  }
  const assigNleave=()=>{
    if(chooseParticipants.length===0){ return  toastInformation('No users selected','warning')}
    onLeave();
    let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
    const socketservice = new SocketChatService(loggeduser.sip_login_id, loggeduser.domain_id);
    socketservice.updateGroupCallHost(activeCallDetail.guid, (chooseParticipants).toString());
    let data:any={};
    data.TeamID=activeCallDetail.guid;
    data.Status="AssignAndLeave";
    data.AssignedHost= (chooseParticipants).toString();
    data.DomainName=loggeduser.domain_name;
    data.CurrentHost=activeCallDetail.isHostId;
    data.DomainId=loggeduser.domain_id;
    socketservice.groupCallSendEvent(data);
    setCallWindow({
      ...getCallWindow, isEndModal: false
    });
  
    
  }
  const searchContact = (e: any) => {
    let searchName = e.toLowerCase();
  
    if (searchName !== "") {
      let filtered = _.filter(tempAllContacts, function (name: any) {
        return name.caller_id?.toLowerCase().includes(searchName) ||
          name.ext?.toString().includes(searchName) || name.team_name?.toLowerCase().includes(searchName);
      });
      setCallWindow({ ...getCallWindow, allContacts: filtered, searchText: searchName });
    }
    else { setCallWindow({ ...getCallWindow, allContacts: tempAllContacts, searchText: '' }); }
  }
  
  const closeAssign =()=>{
    setCallWindow({
      ...getCallWindow, isAssignModal: false,chooseParticipants:[],allContacts:[],tempAllContacts:[]
    });
  }
  
  const change = (val: any, obj: any) => {
    let connectedUsers: Array<any> = filterSingleStatusInGroup(activeCallDetail.groupCallInfo, 'Connected',activeCallDetail.isHostId);
    setCallWindow({
      ...getCallWindow, chooseParticipants: val,
      allContacts: connectedUsers
    });
  
  };
  
const closeEndModal=()=>{
  setData({...getData, isEndModal: false,endId:''});

}


  const mergeCalls = () => {
    
    let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
    const socketservice = new SocketChatService(loggeduser.sip_login_id, loggeduser.domain_id);
    let allCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
    let groupIndex: number = _.findIndex(allCallList, { isGroupCall: true });
    let groupArr:any=  allCallList
    .filter((value: any) => value.isGroupCall === true);
    let internalUsers: any = [];
    let externalUsers: any = [];
    let MergeCall_id:any = [];
    let userNum: any = [];
    let framed: any = {};
    let Exten: any = [];
    let teamID: any = '';
    let MergerequestId: any = '';
    if (groupIndex === -1) {
      allCallList.map((list: any)=>{
        if(list.contact?.ext !== undefined && list?.contact !== undefined ){
          Exten.push(list.contact?.ext?.toString());
          }
        MergeCall_id.push(list['bound'] === "OUT"? list['switchCallId']:list.guid);
        teamID = uuidv4();

        
        if (list.callStatus === "Active"){
          MergerequestId =  list.guid
        }        
        userNum  = list.to === loggeduser.ext ? list.from : list.to;
        userNum.length > 3 ? externalUsers.push(userNum) : internalUsers.push(userNum);        
      })       
      framed.TeamID = teamID;
      framed.Status = "MergeToGroup";
      framed.Host = loggeduser.ext.toString();
      framed.Pstns = externalUsers;
      framed.MergeRequestId = MergerequestId;
      framed.Extensions = Exten;
      framed.DomainName = loggeduser?.domain_name;
      framed.DomainId = loggeduser.domain_id.toString();
      framed.MergeCallIds = MergeCall_id;      

      socketservice.mergeCallSendEvent(framed)
      
      // let externalUsers: any = [];
      // allCallList?.map((calls: any) => {
      //   let userNum: any = calls.to === loggeduser.ext ? calls.from : calls.to;
      //   userNum.length > 3 ? externalUsers.push(userNum) : internalUsers.push(userNum);
      // })
      // internalUsers.push(loggeduser.ext)
      // let guid = uuidv4();
      // framed = frameMultiGroupCall(guid, 'Merge', internalUsers, externalUsers);
      // socketservice.groupCallSendEvent(framed.header)

    }
    else  if(groupArr?.length > 1){
      toastInformation('Two group calls cannot be merged', 'warning')
    }
    else {
      if (allCallList[groupIndex]?.isGroupHost) {
        allCallList?.map((calls: any) => {
          let userNum: any = calls.to === loggeduser.ext ? calls.from : calls.to;
          internalUsers.push(userNum);
        })
        framed = frameMultiGroupCall(allCallList[groupIndex].guid, 'Merge', internalUsers);
        socketservice.groupCallSendEvent(framed.header)
      }
      else {
        toastInformation('Only Host can merge the call', 'warning')
      }
    }

  };

  let fromCallerName :any = incomingInfo?.fromCallerName && (incomingInfo?.fromCallerName !== loggedUserDetails?.caller_id) ? incomingInfo?.fromCallerName.split(' ')[0] + ' + Others' :'You + Others';

  return (
    <>
      <Draggable bounds="parent">
     
        {!incomingInfo.bound ? (

         
          <div
            className={`${
              updatedCallList.callPlusIcon && updatedCallList.callDetails.length === 0
                ? `${Quickstyles.calldialpadScreenright}`
                : styles.calldialpadScreenright
            } ${updatedCallList.callIconStatus === "quickCall" && Quickstyles.quickCallWin}`}
          >
            {updatedCallList.callPlusIcon && updatedCallList.callDetails.length === 0 ? (
              <>
                <div className={Quickstyles.dialpadHeader}>
                  <div className={Quickstyles.downarrowleft} onClick={handleQuickMenuToggle}>
                    {updatedCallList.callIconStatus === "quickCall" ? (
                      <>
                        <Tooltip placement="top" title={"Close"}>
                          <span className={`icon_close ${Quickstyles.forclosing}`}></span>
                        </Tooltip>
                      </>
                    ) : (
                      <>
                        <Tooltip placement="top" title={!getData.isActive ? "Minimise" : "Maximise"}>
                          <span className={getData.isActive ? "icon_down-arrow" : "icon_uparrow"}></span>
                        </Tooltip>
                      </>
                    )}
                  </div>
                  <div className={Quickstyles.calltiming}>
                    <p>Dial Pad</p>
                  </div>
                  <div className={Quickstyles.bottomdownarrow}>
                    <Tooltip placement="top" title="Pop In">
                      <span
                        className="icon_popout"
                        onClick={() => {
                          quickCallMaxWindow(userData);
                        }}
                      ></span>
                    </Tooltip>
                  </div>
                </div>
                {(updatedCallRedux.length === 2 &&activeCallDetail.connectingStatus==='Attended') ?
              (activeCallDetail.consult ?
                (
                  <div className={styles.chatDialCall}>
                    <img src={consultTransferBtnImg} alt="" onClick={attendedCallTransferOpt} />
                    <div className={styles.tooltips}>Complete transfer</div>
                  </div>
                )
                :
                (
                <div className={`${styles.chatDialCall} ${'chatDialCallred'}`}>
<img src={callgreen} alt="" onClick={beforeLeave} />
</div>
)
              )
              :
              ( 
                <div className={`${styles.chatDialCall} ${'chatDialCallred'}`}>
                  {/* <img src={callgreen} alt="" onClick={beforeLeave} /> */}
                </div>
               )
            } 
             {getCallWindow.isKeyPad &&
          <>
            <DialKeypad></DialKeypad>
            <div className={styles.chatDialCall}>
              <img src={callgreen} alt="" onClick={beforeLeave} />
              <p className={styles.hidesection} onClick={openKeypad}>Hide</p>
            </div>
          </>
        }
                {getData.isActive ? (
                  <>
                    <div className={Quickstyles.callpadbottom}>
                      <div className={`${Quickstyles.minimizesetone} ${Quickstyles.showclass} `}>
                        <div className={`${Quickstyles.leftcontent}`}>
                          <CallDialTimer />
                        </div>
                        <ul>
                          <li onClick={openContact}>
                            <span className="icon_contact" />
                          </li>
                          <li onClick={openKeyboard}>
                            <img src={minikeys} alt=""></img>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {getData.contactListshow ? (
                      <div className={Quickstyles.maindialpadscontacts}>
                        <br />
                        <DialPadContactLists
                          contactBackEvent={contactListHide}
                          selectedContact={selectedContactList}
                        ></DialPadContactLists>
                      </div>
                    ) : (
                      <div className={`${Quickstyles.maindialpads} ${Quickstyles.maindialpadshide} callfadein`}>
                        {getData.callInputBox.length !== 0 && (
                          <div className={Quickstyles.showclass}>
                            <DialInputs
                              keyVal={getData.callInputBox}
                              callerName={getData.contactName}
                              keyBoardEvent={dialPadKeyBoardevent}
                              keyBoardBackSpace={dialPadBackSpace}
                            ></DialInputs>
                          </div>
                        )}
                        <DialPadNumber
                          mainCallWindow={mainCallWindow}
                          keyPressEventProps={dialPadKeyevent}
                          ContactList={contactListShow}
                        ></DialPadNumber>
                      </div>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                <div className={styles.dialpadHeader}>
                  {callReducer.callDetails.length > 1 ? (
                    <span> </span>
                  ) : (
                    <div className={styles.downarrowleft} onClick={handleToggle}>
                      {!is_No_Mapping && (
                        <Tooltip placement="top" title={getData.isActiveWindow ? "Minimise" : "Maximise"}>
                          <span className="icon_down-arrow"></span>
                        </Tooltip>
                      )}
                    </div>
                  )}

                  {updatedCallList.callDetails.length > 1 ? (
                    <span> Call Active</span> 
                  ) : (
                    <span>
                      <div className={styles.calltiming}>


{userData?.connectingStatus==='Attended'?<span> {altRecTimer(userData?.callduration)}</span>: <span>  {userData?.connectingStatus} </span>}
                       


                       <p className={styles.Exenum}>
                       {userData?.holdState === true ? (
                          <label className={styles.onholdClr}> onHold</label>
                        ) : (
                          <label className={styles.hdbgClr}> HD</label>
                        )}
                        </p>
                        </div>
                    </span>
                  )}

                  <div className={styles.bottomdownarrow}>
                    <Tooltip placement="top" title="Pop In">
                      <span
                        className="icon_popout"
                        onClick={() => {
                          showCallMaxWindow(userData);
                        }}
                      ></span>
                    </Tooltip>
                  </div>
                </div>
                <div className={!getData.contactListUI ? `${styles.callpadbottom}` : `${styles.headerUI}`}>
                  {is_No_Mapping ? (
                    <>
                      <div className={!getData.contactListUI ? `${styles.callpadbottom}` : `${styles.headerUI}`}>
                        <div
                          className={
                            getData.isActiveWindow
                              ? `${styles.minimizesetone} ${styles.hideclass}`
                              : `${styles.minimizesetone} ${styles.showclass}`
                          }
                        >
                          <div className={styles.leftcontent}>
                            <h3>
                              {/* {userData?.isGroupCall && userData?.holdState
                                ? userData?.callerName
                                : anotherCall?.contact.caller_id}
                                 */}
                                    {
                                    userData?.isGroupCall && userData?.holdState ? (
                                        (userData?.isHostId === loggedUserDetails?.ext.toString()) ? 
                                          (!result ? 'You + Others' : userData?.callerName) :
                                          (!result ? findCallHost(userData?.isHostId) + '+ Others' : userData?.callerName) 
                                    ) : 
                                    anotherCall?.contact.caller_id
                              }
                            </h3>
                            <p className={styles.Exenum}>
                              

                              {userData?.connectingStatus ==="Attended" ? <span> {altRecTimer(anotherCall?.callduration)}</span>: <span> {anotherCall?.connectingStatus} </span>}


                              {anotherCall?.holdState === true ? (
                                <label className={styles.onholdClr}> onHold</label>
                              ) : (
                                <label className={styles.hdbgClr}> HD</label>
                              )}
                            </p>
                          </div>
                          <ul>
                            <li>
                              <img onClick={() => holdCallbtn(userData)} src={gHold} alt=""/>
                            </li>
                              {/* <li onClick={() => callEndWithGiud(anotherCall.guid)}>
                                <img src={callred} alt="" />
                              </li> */}
                          
                          {anotherCall?.isGroupCall ?
                           <>
                            {anotherCall?.isGroupHost ?

                              <li onClick={()=>openEndModel(anotherCall?.guid)}>  

                                <img src={callred} alt="" />
                              </li>
                              :

                              <li onClick={()=>leaveCall(anotherCall?.guid)}>
                                <img src={callred} alt="" />
                              </li>

                            }
                          </>

                          :

                          <li onClick={() => callEndWithGiud(anotherCall?.guid)}>
                            <img src={callred} alt="" />
                          </li>
                          }
                        </ul>



                          {/* <ul>
                            <li>
                              {anotherCall.holdState === false ? 
                              ( <span onClick={() => holdCallbtn(anotherCall)} className={"icon_microphone"}></span>) : 
                              updatedCallList.callDetails.length > 1 ? (
                                <img
                                  onClick={() => {
                                    toastInformation("Future Implementation", "failure");
                                  }}
                                  src={gtransfer}
                                  alt=""
                                />
                              ) : updatedCallList.callDetails.length === 0 ? (
                                <img onClick={() => holdCallbtn(anotherCall)} src={gHold} alt=""></img>
                              ) : (
                                <span onClick={() => holdCallbtn(anotherCall)}>
                                  {" "}
                                  <img src={gHold} alt=""></img>
                                </span>
                              )}
                            </li>
                            <li onClick={() => callEndWithGiud(anotherCall.guid)}>
                              <img src={callred} alt="" />
                            </li>
                          </ul> */}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {anotherCall?.map((elem: any, index: number) => {
                        let userInfo: any = frameCallProfile(elem);
                        let { teamContacsnew }: contacts = store.getState().contactReducer || [];
                        let result:boolean = false;
                        Object.keys(teamContacsnew).forEach((gKey: any) => {
                          let newKey: any = teamContacsnew[gKey];
                          Object.keys(newKey).forEach((member: any) => {
                            if (((newKey['team_name']) === userInfo?.combinedNames[0]))
                            {
                            result =true;
                            } 
                          });
                        });
                        return (
                          <>
                            <div key={index} className={!getData.contactListUI ? `${styles.callpadbottom}` : `${styles.headerUI}`}>
                              <div className={getData.isActiveWindow
                                    ? `${styles.minimizesetone} ${styles.hideclass}`
                                    : `${styles.minimizesetone} ${styles.showclass}`
                                }
                              >
                                <div className={styles.leftcontent}>
                                {/* <h3>{result ? userInfo?.callerName : (userInfo?.isHostId !== loggedUserDetails?.ext) ? findCallHost(userInfo?.isHostId) + '+ Others': 'You + Others'}</h3> */}
                                <h3>
                                { userInfo?.combinedNames?.length !== 0 ? (( userInfo?.isGroupHost ? (!result ? 'You + Others' : userInfo?.combinedNames[0] + (userInfo?.combinedNames?.length !== 1 ? '+ Others' :'' )) :
                                                                              (!result ? `${findCallHost(userInfo?.isHostId)} + Others` : userInfo?.combinedNames[0] + (userInfo?.combinedNames?.length !== 1 ? '+ Others' :'') ))) :   
                                                                             userInfo?.callerName                                                                             
                                }
                                </h3>
                                  {/* { (elem.isAudioWave ===  true && userData.isGroupCall === true ) ? <span className={styles.callextnotxt}> 
                                  <object data={audioWave} type="image/svg+xml"> </object> {elem.activeSpeakerName} </span> : <span className={styles.callextnotxt}>{`${userData.isGroupCall ? "Group Call" : "Extension"}`} {userInfo.ext} </span>} */}

                                  {userData?.isGroupCall ? <span className={styles.callextnotxt}>Group Call</span>
                                    : <span className={styles.callextnotxt}> Extension: {userInfo?.ext} </span>
                                  }
                                 { updatedCallList.callDetails.length > 1 && <div className={styles.calltiming}>

                                 {userData?.connectingStatus==='Attended'?<span>{altRecTimer(userInfo?.callduration)}</span>: <span>  {userInfo?.connectingStatus}</span>}

                                        {/* <p> {altRecTimer(elem.callduration)} </p> */}

                                        <p className={styles.Exenum}>
                                      {userInfo?.holdState === true ? (
                                        <label className={styles.onholdClr}> onHold</label>
                                      ) : (
                                        <label className={styles.hdbgClr}> HD</label>
                                      )}
                                       </p>

                                      </div>}
                                    
                                  
                                  {/* <span>
                                    {callReducer.callDetails = 2 && (
                                      <div className={styles.calltiming}>
                                        <p> {altRecTimer(elem.callduration)} </p>
                                      </div>
                                    )}
                                  </span>
                                  {callReducer.callDetails = 1 && (
                                    <p className={styles.Exenum}>
                                      Extension <span> {userInfo.ext}</span>
                                      {userInfo.holdState === true ? (
                                        <label className={styles.onholdClr}> onHold</label>
                                      ) : (
                                        <label className={styles.hdbgClr}> HD</label>
                                      )}
                                    </p>
                                  )} */}
                                </div>
                                <ul>
                                 {updatedCallList.callDetails.length > 1  ? <li>
                                    {userInfo?.holdState === false ? (
                                      <img
                                      onClick={() => mergeCalls()}
                                      src={gtransfer}
                                      alt=""
                                    />
                                    ) : <img onClick={() => holdCallbtn(userInfo)} src={gHold} alt=""></img> }
                                  </li> : 
                                  <li>
                                    {userInfo?.muteState === false ? (
                                      <span onClick={groupCurrentUserMute} className={"icon_microphone"}></span>
                                    ) : <span onClick={groupCurrentUserMute} className={"icon_Unmute"}></span>
                                    }
                                  </li> }
                                  
                                  {userInfo?.isGroupCall === true ?
                                    <>
                                      {userInfo?.isGroupHost ?
                                        <li onClick={()=>openEndModel(userInfo?.guid)}> <img src={callred} alt="" /></li>
                                        :

                                        <li onClick={()=>leaveCall(userInfo?.guid)}><img src={callred} alt="" /> </li>}
                                    </>
                                    :
                                    <li onClick={() => callEndWithGiud(userInfo?.guid)}>
                                      <img src={callred} alt="" /></li>}
                                </ul>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </>
                  )}

                  <div
                    className={
                      getData.isActiveWindow
                        ? `${styles.minimizesetthree} ${styles.showclass} ${'formini'}`
                        : `
                    ${styles.minimizesetthree} ${styles.hideclass}`
                    }
                  >
                    {/* {conferenceDetails.isConference && !conferenceDetails.isNewCall ?
                      (<ConferenceCalls confDetail={conferenceDetails.list}
                        callDetail={updatedCallList.callDetails}></ConferenceCalls>)
                      :
                      (
                        <>
                          {updatedCallList.callDetails.length === 1 ?
                            (<DialConnecting callDetail={updatedCallList.callDetails}></DialConnecting>)
                            :
                            (<TransferCalls updatedCallList={updatedCallList} confDetail={conferenceDetails}></TransferCalls>)
                          }
                        </>
                      )
                    } */}
                    <DialConnecting callDetail={updatedCallList.callDetails}></DialConnecting>

                    {/* <CallMainWindow dialpadUI={addCallContactNodata}></CallMainWindow> */}
                    <CallMainWindowTeam></CallMainWindowTeam>

                  </div>
                </div>
              </>
            )}   
          </div>
        ) : (
          <div className={styles.calldialpadScreenright}>
            <div className={styles.dialpadHeader}>
              <div className={styles.calltiming}>
                <p>Incoming Call...</p>
              </div>
            </div>
            <div className={styles.callpadbottom}>
              <div className={`${styles.minimizesetone} ${styles.showclass}`}>
                {callReducer.callDetails.length === 0 ? (
                  <>
                    <div className={styles.leftcontent}>
                      <h3>{incomingInfo?.isGroupCall ? fromCallerName: incomingInfo?.fromCallerName}</h3>
                      <p className={styles.Exenum}>
                        Extension <span> {incomingInfo?.fromcaller}</span>
                      </p>
                    </div>
                    <ul>
                      <li onClick={calldenied}>
                        <img src={callred} alt="" />
                      </li>
                      <li onClick={CallAcceptBtn} id="callAccept" >
                        <img src={callgreen} alt="" />
                      </li>
                    </ul>
                  </>
                ) : (
                  <>
                  <div className={styles.newincomingcall}>

                      <div className={styles.leftcontent}>
                        <h3>{incomingInfo?.isGroupCall ? fromCallerName: incomingInfo?.fromCallerName}</h3>
                        <p className={styles.Exenum}>Extension <span> {incomingInfo?.fromcaller}</span></p>
                      </div>
                      <ul>
                        <li onClick={endAndAccept}>
                          <img src={groupCallEndatyn} alt="" className="noborder" />
                          <p>End & Attend</p>
                        </li>
                        <li onClick={holdAndAccept}>
                          <img src={groupCallhldAtyn} alt="" className="noborder" />
                          <p>Hold & Attend</p>
                        </li>
                        <li onClick={calldenied}>
                          <img src={callred} alt="" />
                          <p>End</p>
                        </li>
                      </ul></div>
                      </>    
                )}
              </div>
            </div>
           
          </div>
          
                   
        )}
      </Draggable>
      <Modal visible={getData.isEndModal} className={`${styles2.flipcallmodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles2.cursorTop}`} onClick={cancelEndModal} />
        <h2>End Call?</h2>
        <span> Are you sure want to end the call?</span>
        <div className={styles2.footersection}>      
          <URButton className={styles2.cancelbtn} name="Leave Call" onClick={beforeLeave}></URButton>
          <URButton className={styles2.endAll} name="End Call for All" onClick={callEndForGroup}></URButton>
        </div>
      </Modal>
      <Modal visible={getCallWindow.isAssignModal} className={`${styles.flipcallmodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={closeAssign} />
        <h2>Assign Host</h2>
        {/* <span> Are you sure want to end the call?</span> */}

        <div className={styles.insideicon}>
              <Select
                style={{ width: '100%' }}
                /*  optionLabelProp="label" */
                filterOption={false}
                showSearch={true}
                value={chooseParticipants}
                defaultValue={chooseParticipants}
                onSearch={searchContact}
                placeholder="Enter name or extension"
                className="newselects"
                onChange={change}
              >
                {SpecificMemberLists(searchText,allContacts, true)}

                
              </Select>
            </div>
        <div className={styles.footersection}> 
          <URButton className={styles.cancelbtn} name="Cancel" onClick={closeAssign}></URButton>
          <URButton className={styles.endAll} name="Assign and Leave" onClick={assigNleave}></URButton>
        </div>
      </Modal>
    </>
  );

  /*  return (
    <Draggable>
      <>
      {updatedCallList.callPlusIcon && updatedCallList.callDetails.length === 0 ?
          (
            <>
              <div className={`${Quickstyles.calldialpadScreenright} ${updatedCallList.callIconStatus === 'quickCall' && Quickstyles.quickCallWin}`}>
                <div className={Quickstyles.dialpadHeader}>
                  <div className={Quickstyles.downarrowleft} onClick={handleQuickMenuToggle}>
                    {updatedCallList.callIconStatus === 'quickCall' ?
                      (
                        <>
                          <Tooltip placement="top" title={'Close'}>
                            <span className={`icon_close ${Quickstyles.forclosing}`}></span>
                          </Tooltip>
                        </>
                      )
                      :
                      (
                        <>
                          <Tooltip placement="top" title={!getData.isActive ? 'Minimise' : 'Maximise'}>
                            <span className={getData.isActive ? "icon_down-arrow" : "icon_uparrow"}></span>
                          </Tooltip>
                        </>
                      )
                    }
                  </div>
                  <div className={Quickstyles.calltiming}><p>Dial Pad</p></div>
                  <div className={Quickstyles.bottomdownarrow}>
                    <Tooltip placement="top" title="Pop In">
                      <span className="icon_popout" onClick={quickCallMaxWindow}></span>
                    </Tooltip>
                  </div>
                </div>

                {getData.isActive ?
                  (
                    <>
                      <div className={Quickstyles.callpadbottom}>
                        <div className={`${Quickstyles.minimizesetone} ${Quickstyles.showclass}`}>
                          <div className={Quickstyles.leftcontent}>
                            <CallDialTimer />
                          </div>
                          <ul>
                            <li onClick={openContact}><span className="icon_contact" /></li>
                            <li onClick={openKeyboard}><span className="icon_Keypadoutline" /></li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )
                  :
                  (
                    <>
                      {getData.contactListshow ?
                        (<div className={Quickstyles.maindialpadscontacts}>
                          <br />
                          <DialPadContactLists contactBackEvent={contactListHide}
                            selectedContact={selectedContactList}></DialPadContactLists>
                        </div>)
                        :
                        (
                          <div className={`${Quickstyles.maindialpads} ${Quickstyles.maindialpadshide}`}>
                            {getData.callInputBox.length !== 0 &&
                              <div className={Quickstyles.showclass}>
                                <DialInputs keyVal={getData.callInputBox} callerName={getData.contactName}
                                  keyBoardEvent={dialPadKeyBoardevent} keyBoardBackSpace={dialPadBackSpace}></DialInputs>
                              </div>
                            }
                            <DialPadNumber mainCallWindow={mainCallWindow} keyPressEventProps={dialPadKeyevent}
                              ContactList={contactListShow} ></DialPadNumber>
                          </div>
                        )
                      }
                    </>
                  )
                }
              </div>
            </>
          )
          :
          (
              <div className={`${styles.calldialpadScreenright} ${updatedCallList.callIconStatus === 'quickCall' && Quickstyles.quickCallWin}`}>
                <div className={styles.dialpadHeader}>
                  <div className={styles.downarrowleft} onClick={handleToggle}>
                    <Tooltip placement="top" title={getData.isActiveWindow ? 'Minimise' : 'Maximise'}>
                      <span className="icon_down-arrow"></span>
                    </Tooltip>
                  </div>
                  <div className={styles.calltiming}><p> {altRecTimer(userData.callduration)}<span>HD</span></p></div>
                  <div className={styles.bottomdownarrow}>
                    <Tooltip placement="top" title="Pop In">
                      <span className="icon_popout" onClick={showCallMaxWindow}></span>
                    </Tooltip>
                  </div>
                </div>
                <div className={!getData.contactListUI ? `${styles.callpadbottom}` : `${styles.headerUI}`}>
                  <div className={getData.isActiveWindow ? `${styles.minimizesetone} ${styles.hideclass}` :
                    `${styles.minimizesetone} ${styles.showclass}`}>
                    <div className={styles.leftcontent}>
                      {conferenceDetails.isConference && !conferenceDetails.isNewCall ?
                        (<><h3>Conference Calls</h3></>)
                        :
                        (
                          <>
                            <h3>{userData.callerName}</h3>
                            <p className={styles.Exenum}>Extension <span> {userData.ext}</span></p>
                          </>
                        )
                      }
                    </div>
                    <ul>
                      <li onClick={muteCall}>
                        <span className={userData.muteState ? "icon_Unmute" : "icon_microphone"}></span></li>
                      <li onClick={callEndFunction}><img src={callred} alt="" /></li>
                    </ul>
                  </div>

                  <div className={getData.isActiveWindow ? `${styles.minimizesetthree} ${styles.showclass}` : `
          ${styles.minimizesetthree} ${styles.hideclass}`}>

                    {conferenceDetails.isConference && !conferenceDetails.isNewCall ?
                      (<ConferenceCalls confDetail={conferenceDetails.list}
                        callDetail={updatedCallList.callDetails}></ConferenceCalls>)
                      :
                      (
                        <>
                          {updatedCallList.callDetails.length === 1 ?
                            (<DialConnecting callDetail={updatedCallList.callDetails}></DialConnecting>)
                            :
                            (<TransferCalls updatedCallList={updatedCallList} confDetail={conferenceDetails}></TransferCalls>)
                          }
                        </>
                      )
                    }
                    <CallMainWindow dialpadUI={addCallContactNodata}></CallMainWindow>
                  </div>
                </div>
              </div>
          )
        }
        </>
      </Draggable>
  ); */
};
export default CallMiniWindowScreen;
